<template>
    <div id="task-drawer">
        <a-drawer :visible="true" title="Tasks" placement="right" @close="$emit('close')">
            <div v-for="task in tasks" :key="task._id" class="task-item">
                <a-radio @change="markCompleted(task._id)" />
                <div class="info">
                    <div class="info-title">{{ task.title }}</div>
                    <div class="info-description">{{ task.description }}</div>
                    <div class="info-time">
                        <div class="info-time-item">{{ getDateFormat(task.startDate) }}</div>
                        <div class="info-time-item">{{ getTimeFormat(task.startTime) }}</div>
                    </div>
                </div>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment";

moment.locale("tr");
const log = log2("TaskDrawer");
export default {
    name: "TaskDrawer",
    components: {},
    props: {},
    data() {
        return {
            tasks: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getTaskEvents: "calendar/getTaskEvents",
            markCompletedTask: "calendar/markCompletedTask",
        }),
        ...mapMutations({}),
        markCompleted(eventId) {
            console.log("markCompleted", eventId);
            this.markCompletedTask({ eventId }).then((res) => {
                console.log("res", res);
                this.tasks = this.tasks.filter((task) => task._id !== eventId);
                this.$message.success("Görev tamamlandı olarak işaretlendi.");
            });
        },
        getDateFormat(date) {
            return moment(date).subtract(10, "days").calendar();
        },
        getTimeFormat(date) {
            return moment(date).format("LT");
        },
    },
    async mounted() {
        this.getTaskEvents({ userId: this.user._id }).then((res) => {
            console.log("res", res);
            this.tasks = res;
        });
    },
    watch: {},
};
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.task-item {
    display: flex;

    .info {
        .info-title {
            font-weight: 700;
            font-size: 14px;
        }

        .info-description {
            font-size: 12px;
        }

        .info-time {
            display: flex;

            .info-time-item {
                font-size: 12px;
            }
        }
    }
}

#task-drawer {
    background-color: #ffffff;
    height: 100%;
}
</style>
